import { defineStore } from "pinia";
import { computed, onMounted, ref, watch } from "vue";
import ApiService from "@/core/services/ApiService";
import { Mutations } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import apiService from "@/core/services/ApiService";
import userInfo from "@/core/services/UserInfo";

export const TodoSupport = defineStore("TodoSupportInfo", () => {
  const user = userInfo.getUser();
  const store = useStore();
  // state
  const activeBoardId = ref(window.localStorage.getItem("activeBoardId"));
  const boardsList = ref();

  watch(
    () => activeBoardId.value,
    () => {
      if (activeBoardId.value)
        window.localStorage.setItem("activeBoardId", activeBoardId.value);
      fetchTodosCategory();
      fetchTodos();
    }
  );

  const todos = ref();
  const categories = ref();
  const targetTodoId = ref();
  const comments = ref();
  const loadingCategory = ref(false);
  const admins = computed(() => {
    return [
      {
        id: 2,
        first_name: "محمد",
        last_name: "حمیدیا",
        mobile: "+989120240619",
        picture:
          "https://back.inboxino.com/public/storage/users/TBe6mQcgpwQKRSz12iUy274XpoupYo23ZOosruWn.jpg",
      },
      {
        id: 38,
        first_name: "پاسخگوی‌خودکار",
        last_name: "اینباکسینو",
        mobile: "+989351132076",
        picture:
          "https://back.inboxino.com/public/storage/users/aAQelPlaYWKSZnqE6eX6bJkBg2EOaipjux8Zn9nt.jpg",
      },
      {
        id: 14,
        first_name: "فاطمه",
        last_name: "عمارلو",
        mobile: "+989150014696",
        picture:
          "https://back.inboxino.com/public/storage/avatars/default-woman.jpg",
      },
      {
        id: 3273,
        first_name: "صالح",
        last_name: "قانع",
        mobile: "+989128489128",
        picture:
          "https://back.inboxino.com/public/storage/users/AlzHcfWoG0qYkgHmHNNi1OCAmpCwNkRKZHOX1gCS.jpg",
      },
      {
        id: 1,
        first_name: "بهزاد",
        last_name: "عزیزان",
        mobile: "+989396672440",
        picture:
          "https://back.inboxino.com/public/storage/users/UtnbmWiqU7BLOHakG5MEDDCj7360duNOtZdbeCPb.jpg",
      },
      {
        id: 168,
        first_name: "حامد",
        last_name: "بابازاده",
        mobile: "+989376080467",
        picture:
          "https://back.inboxino.com/public/storage/users/ZkOznG9d4JicNDaRixiLKIJqT3JrzGR7CbiG72JR.jpg",
      },
    ];
  });

  const activeCategoryId = ref();

  const filter = ref({
    assign_admins: [] as any, // id 1,2
    for_customers: [] as any, // id 5,6
    tags: [],
    platforms: [],
    only_my_tasks: true,
  });

  const checkFiltersHaveValue = computed(() => {
    if (filter.value.assign_admins && filter.value.assign_admins.length > 0) {
      return false;
    }
    return true;
  });

  watch(filter.value, () => {
    if (user && user.type !== "user") {
      fetchTodos();

      window.localStorage.setItem(
        "only_my_tasks",
        `${filter.value.only_my_tasks}`
      );
    }
  });

  onMounted(() => {
    const getOnlyMyTasks = window.localStorage.getItem("only_my_tasks");
    filter.value.only_my_tasks = getOnlyMyTasks === "true";
  });

  const targetTodoUpdate = computed(() => {
    return {
      title: targetTodo.value?.title,
      description: targetTodo.value?.description,
      thumbnail: undefined,
      color: targetTodo.value?.color,
      category_id: targetTodo.value?.category.id,
      sort: targetTodo.value?.sort,
      platforms: targetTodo.value?.platforms,
      duration: targetTodo.value?.duration,
      tags: targetTodo.value?.tags,
      todo_list: targetTodo.value?.todo_list,
      extra_fields: targetTodo.value?.extra_fields,
      assign_admins:
        targetTodo.value && targetTodo.value.assign_admins
          ? targetTodo.value.assign_admins.map((item) => {
              return item.id;
            })
          : [],
      for_customers:
        targetTodo.value && targetTodo.value.for_customers
          ? targetTodo.value.for_customers.map((item) => {
              return item.id;
            })
          : [],
      setting: {
        enable_auto_reminders: undefined,
        remind_every: undefined,
      },
    };
  });

  // getters
  const targetTodo = computed(() => {
    if (!targetTodoId.value) return;
    return todos.value.find((todo) => todo.id === targetTodoId.value);
  });

  const activeBoardInfo = computed(() => {
    if (!boardsList.value) return;
    return boardsList.value.find(
      (item) => item.id === Number(activeBoardId.value)
    );
  });

  const setTargetTodoId = (todo_id) => {
    targetTodoId.value = todo_id;
  };

  const setTargetTodo = async (event, todo, moveHolder) => {
    targetTodoId.value = todo["element"].id;
    if (event === "moved") {
      todos.value.forEach((obj) => {
        if (obj.id === targetTodoId.value) {
          obj.sort = todo.newIndex;
        } else if (todo.newIndex >= obj.sort) {
          obj.sort = obj.sort + 1;
        }
      });
    } else if (event === "added") {
      if (moveHolder.to > 0) {
        // if cat_id is existed
        todos.value.forEach((obj) => {
          if (obj.id === targetTodoId.value) {
            obj.category.id = Number(moveHolder.to);
          }
        });
      }

      await updateTodoInEvent();
    }
  };

  const storeTodo = async (newTodo) => {
    try {
      newTodo["board_id"] = Number(activeBoardId.value);
      const { data } = await ApiService.post(
        "admin/support/task/create",
        newTodo
      );
      todos.value.push(data.data.task);
      return data;
    } catch (error) {
      if (error.response && error.response.data)
        store.commit(Mutations.SET_ERROR, error.response.data);
      return error;
    }
  };

  const sortTodos = (from, to) => {
    const item = todos.value
      .filter((obj) => {
        if (obj.category) return obj.category.id === Number(to);
      })
      .sort((a, b) => a.sort - b.sort)
      .map((obj) => obj.id);

    ApiService.post("admin/support/task/sort", {
      board_id: Number(activeBoardId.value),
      category_id: Number(to),
      tasks: item,
    })
      .then(() => {
        //
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const updateTodoInEvent = () => {
    targetTodoUpdate.value["board_id"] = Number(activeBoardId.value);
    ApiService.post(
      `admin/support/task/${targetTodoId.value}/edit`,
      targetTodoUpdate.value
    )
      .then(() => {
        // todos.value.forEach((obj) => {
        //   if (obj.id === targetTodoId.value) {
        //     obj = data.data.task;
        //   }
        // });
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const deleteTodo = (todo_id) => {
    ApiService.post(`admin/support/task/${todo_id}/delete`, {})
      .then(() => {
        todos.value = todos.value.filter((obj) => obj.id !== todo_id);
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const fetchTodos = () => {
    loadingCategory.value = true;
    ApiService.query("admin/support/task", {
      params: {
        board_id: Number(activeBoardId.value),
        assign_admins:
          filter.value && filter.value.assign_admins.length > 0
            ? filter.value.assign_admins
            : null,
        for_customers:
          filter.value && filter.value.for_customers.length > 0
            ? filter.value.for_customers
            : null,
        tags: filter.value.tags ? filter.value.tags : null,
        only_my_tasks: filter.value.only_my_tasks,
      },
    })
      .then(({ data }) => {
        todos.value = data.data.tasks.sort((a, b) => a.sort - b.sort);
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      })
      .finally(() => {
        loadingCategory.value = false;
      });
  };

  const fetchTodosCategory = () => {
    loadingCategory.value = true;
    ApiService.get(
      `admin/support/task-category?board_id=${Number(activeBoardId.value)}`
    )
      .then(({ data }) => {
        categories.value = data.data.task_categories;
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      })
      .finally(() => {
        loadingCategory.value = false;
      });
  };

  const getComments = () => {
    apiService
      .get(`/admin/support/task-comment/${targetTodoId.value}`)
      .then(({ data }) => {
        comments.value = data.data.comments;
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const sendComments = async (comment) => {
    try {
      comment["task_id"] = targetTodoId.value;
      const { data } = await apiService.post(
        "admin/support/task-comment/send",
        comment
      );
      comments.value.push(data.data.comment);
      return data;
    } catch (error) {
      if (error && error.response.data)
        store.commit(Mutations.SET_ERROR, error.response.data);
      return error;
    }
  };

  const toggleTodo = (list_id) => {
    apiService
      .post(
        `admin/support/task/${targetTodoId.value}/toggle-todo/${list_id}`,
        {}
      )
      .then(() => {
        todos.value.forEach((obj) => {
          if (obj.id === targetTodoId.value) {
            // obj.category.id = Number(moveHolder.to);
            obj.todo_list.forEach((list) => {
              if (list.id === list_id) list.checked = !list.checked;
            });
          }
        });
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const updateTodo = (todo) => {
    todo["board_id"] = Number(activeBoardId.value);
    ApiService.post(`admin/support/task/${targetTodoId.value}/edit`, todo)
      .then(({ data }) => {
        todos.value = todos.value.map((item) => {
          if (item.id === targetTodoId.value) return data.data.task;
          return item;
        });
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const fetchBoard = () => {
    apiService
      .get(`admin/board`)
      .then(({ data }) => {
        boardsList.value = data.data.boards;
        if (!activeBoardId.value) {
          activeBoardId.value = boardsList.value[0]?.id;
        }
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const deleteBoard = (id) => {
    ApiService.post(`admin/board/${id}/delete`, {})
      .then(() => {
        activeBoardId.value = null;
        fetchBoard();
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const editBoard = (id, board) => {
    ApiService.post(`admin/board/${id}/edit`, {
      title: board.title,
    })
      .then(() => {
        fetchBoard();
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  const storeBoard = (board) => {
    ApiService.post(`admin/board/create`, {
      title: board.title,
    })
      .then(({ data }) => {
        boardsList.value.push(data.data.board);
        activeBoardId.value = data.data.board.id;
      })
      .catch(({ response }) => {
        if (response && response.data)
          store.commit(Mutations.SET_ERROR, response.data);
      });
  };

  watch(targetTodoId, () => {
    getComments();
  });

  return {
    // category
    categories,
    activeCategoryId,
    fetchTodosCategory,

    // todos
    todos,
    targetTodo,
    comments,
    targetTodoId,
    filter,
    admins,
    loadingCategory,
    checkFiltersHaveValue,
    storeTodo,
    fetchTodos,
    setTargetTodo,
    deleteTodo,
    setTargetTodoId,
    sendComments,
    toggleTodo,
    updateTodo,
    sortTodos,

    // board
    activeBoardId,
    activeBoardInfo,
    boardsList,
    storeBoard,
    fetchBoard,
    deleteBoard,
    editBoard,
  };
});
